module.exports = __webpack_public_path__ + "img/client-3.4b3125c.png";